import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class SetBVIDoneComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <Button className={this.props.className} onClick={this.props.done}>Verwijder van bord</Button>
      </Container>
    );
  }
}

SetBVIDoneComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    done() {
      dispatch(
        setVehicleProperty(ownProps.vehicle.id, 'bvi_done', '1', () => {
          dispatch(refreshBoards());
          if (ownProps.onComplete) ownProps.onComplete();
        }),
      );
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const SetBVIDone = compose(
  withConnect,
  withRouter,
)(SetBVIDoneComp);
